import React, { Dispatch, SetStateAction } from "react";
import TitleDrawer from "@components/drawer/TitleDrawer";
import styled from "@emotion/styled";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "2rem",
});

const TitleBox = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "2.4rem",
  fontWeight: theme.fontWeight.bold,
  lineHeight: "3.6rem",
  margin: "2rem 0",
}));

const StepWrapper = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "2rem",

  ".ex": {
    color: theme.color.dark_gray,
    fontSize: "1.4rem",
    lineHeight: "1.6rem",
    fontWeight: theme.fontWeight.bold,
    textAlign: "center",
  },
}));

const DescBox = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  color: "#757575",
  fontSize: "1.4rem",
  lineHeight: "2rem",
  fontWeight: theme.fontWeight.medium,
}));

const ImageBox = styled.div({
  width: "100%",
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: "1.5rem",
});

const StepTitleBox = styled.div(({ theme }) => ({
  position: "relative",
  fontSize: "2rem",
  lineHeight: "2rem",
  fontWeight: theme.fontWeight.bold,
  backgroundColor: theme.color.mint,
  overflow: "visible",
}));

const StepTitle = styled.div({
  position: "relative",
  top: "-0.8rem",
});

type Props = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

const RegisterTipDrawer = ({ open, setOpen }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <TitleDrawer
      open={open}
      setOpen={setOpen}
      title="상품등록 TIP 타이틀"
      closeIcon>
      <Container>
        <TitleBox>
          <span>{t("판매자를 위한")}</span>
          <span>{t("잘 팔리는 상품 등록 TIP")}</span>
        </TitleBox>

        <StepWrapper>
          <StepTitleBox>
            <StepTitle>{t("1. 흰 배경에 제품을 찍어주세요")}</StepTitle>
          </StepTitleBox>

          <DescBox>
            <span>{t("예쁘게 촬영된 상품 이미지가 없을경우,")}</span>
            <span>{t("흰 배경에 사진을 찍으면 판매될 확률이 올라가요!")}</span>
          </DescBox>

          <ImageBox>
            <Image src={theme.image.tip_1_1} width="100%" height="100%" />

            <Image src={theme.image.tip_1_2} width="100%" height="100%" />
          </ImageBox>

          <span className="ex">{t("상품 예시 이미지")}</span>
        </StepWrapper>

        <StepWrapper>
          <StepTitleBox>
            <StepTitle>{t("2. 설명, 사진은 디테일하게")}</StepTitle>
          </StepTitleBox>

          <DescBox>
            <span>
              {t(
                "설명이 자세하고, 디테일하게 찍은 사진일수록 신뢰도가 올라가고, 분쟁이나 반품의 확률이 낮아져요.",
              )}
            </span>
          </DescBox>

          <ImageBox>
            <Image src={theme.image.tip_2_1} width="100%" height="100%" />

            <Image src={theme.image.tip_2_2} width="100%" height="100%" />
          </ImageBox>

          <span className="ex">{t("상품 예시 이미지")}</span>
        </StepWrapper>

        <StepWrapper>
          <StepTitleBox>
            <StepTitle>{t("3. 하자 부분은 잘 보이게!")}</StepTitle>
          </StepTitleBox>

          <DescBox>
            <span>
              {t(
                "얼룩이나 뜯어짐 등등 하자부분이 잘보이게 찍어주세요. 얼룩이나 뜯어짐 등등 하자부분이 잘 보이게 찍어주세요.",
              )}
            </span>
          </DescBox>

          <ImageBox>
            <Image src={theme.image.tip_3_1} width="100%" height="100%" />

            <Image src={theme.image.tip_3_2} width="100%" height="100%" />
          </ImageBox>

          <span className="ex">{t("상품 예시 이미지")}</span>
        </StepWrapper>
      </Container>
    </TitleDrawer>
  );
};

export default RegisterTipDrawer;
